/* eslint @typescript-eslint/naming-convention: 0 */

import { buildEventParams, type EventParams } from '@/wabunka-src/common/utils/googleAnalytics/common/event';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

export interface SelectEventParams {
  item_id: string;
  item_name: string;
  date: string;
  events: EventParams[];
}

const buildSelectEventParams = (experienceEvent: WabunkaExperienceEventViewModel, date: string): SelectEventParams => {
  return {
    item_id: experienceEvent.experience.id,
    item_name: experienceEvent.experience.name,
    date,
    events: [buildEventParams(experienceEvent)],
  };
};

/**
 * 発火タイミング：体験イベント開催時間選択時
 */
export const sendGAWabunkaSelectEvent = (experienceEvent: WabunkaExperienceEventViewModel, date: string) => {
  sendWabunkaGAEvent('select_event', buildSelectEventParams(experienceEvent, date));
};
